export enum CustomerVenueGroupCriteria {
	VISITCOUNT = 1,
	TOTALREVENUE = 2,
	AVERAGESPEND = 3,
	FIRSTVISIT = 4,
	LASTVISIT = 5,
	PURCHASEDITEM = 6,
}
